import React from 'react'

import { minutesToText } from 'modules/core/lib/duration'

type Props = {
  allocatedMinutes: number
  totalAvailableMinutes: number
  hasError?: boolean
}

const AllocationSummary = ({ allocatedMinutes, totalAvailableMinutes, hasError }: Props) => {
  const allocatedText = minutesToText(allocatedMinutes)
  const totalText = minutesToText(totalAvailableMinutes)
  const exceedsBalance = allocatedMinutes > totalAvailableMinutes

  return (
    <div className="flex justify-between items-center">
      <span className="text-base font-normal text-f1-foreground-secondary">Allocated hours</span>
      <span
        className={`text-base font-semibold ${
          exceedsBalance || hasError ? 'text-red-600' : 'text-gray-800'
        }`}
      >
        {allocatedText} / {totalText}
      </span>
    </div>
  )
}

export default AllocationSummary
